import React from "react";

import { skillArray } from "../constants/skillList";
import { SkillCard } from "./SkillCard ";
// className='shadow-xl p-10 rounded-lg '



const Skills = () => {
  return (
    <div className="w-full text-center mt-20 p-10">
      <h2 className="text-white/90 font-thin  text-center text-xl md:text-4xl md:pt-5">Skills</h2>
      <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-6 text-white p-10">
        {skillArray.map((skill, index) => (
          <SkillCard key={index} {...skill} />
        ))}
      </div>
    </div>
  );
};

export default Skills;
